<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
        <v-card
            class="pa-6" 
            width="500"
        >  
            <v-app-bar
                flat
                :color="themeColor"
            >
                <v-toolbar-title class="title white--text pl-0">
                    STUDENT INFORMATION
                </v-toolbar-title>
            </v-app-bar>
        </v-card>
        </v-row>
        <v-row
            align="center"
            justify="center"
            v-for="section in sections"
            :key="section.label"            
        >
            <v-card
                class="pa-6 mt-5" 
                width="500"
                v-if="section.display"
            >
                <v-row 
                    align="center"
                    justify="center"
                    v-for="field in sectionFields(section.number)"
                    :key="field.label"
                >
                    <v-col
                        cols="12"                       
                    >
                        <v-autocomplete
                            v-if="field.type == 'select' && field.label == 'Town'"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            :items="field.items"
                            :item-text="field.text"
                            :item-value="field.value"
                            @blur="validateSection"
                            chips
                            clearable
                            :prepend-icon="field.icon"
                            :placholder="field.placeholder"
                            :rules="[()=> !!studentRecord[field.model] || 'This field is required.']"
                            :ref="field.ref"
                        ></v-autocomplete>
                    
                        <v-autocomplete
                            v-else-if="field.type == 'select' && field.required"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            :items="field.items"
                            :item-text="field.text"
                            :item-value="field.value"                        
                            @change="validateSection"
                            chips
                            clearable
                            :prepend-icon="field.icon"
                            :placholder="field.placeholder"
                            :disabled="field.disabled"
                            :filled="field.filled"
                            :rules="[()=> !!studentRecord[field.model] || 'This field is required.']"
                            :ref="field.ref"                           
                        ></v-autocomplete>

                        <v-autocomplete
                            v-else-if="field.type == 'select'"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            :items="field.items"
                            :item-text="field.text"
                            :item-value="field.value"                        
                            @change="validateSection"
                            chips
                            clearable
                            :prepend-icon="field.icon"
                            :placholder="field.placeholder"
                            :disabled="field.disabled"
                            :filled="field.filled"                            
                            :ref="field.ref"                           
                        ></v-autocomplete>
                   
                        <v-row
                            v-else-if="field.type == 'switch'"
                            align="center"
                            justify="center"                            
                        >
                            <v-col cols="9">
                                {{ field.label }}
                            </v-col>

                            <v-col
                                class="d-flex"                        
                                cols="3"                    
                            >
                                <v-switch
                                    v-model="immigrationPermit"
                                    :label="setLabel(immigrationPermit)"
                                    @change="toggleImmigration"
                                    :ref="field.ref"                                    
                                ></v-switch>
                            </v-col>
                        </v-row> 

                        <v-text-field
                            v-else-if="field.type == 'phone-number'"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            @blur="validateSection"
                            :prepend-icon="field.icon"
                            placeholder=" "
                            hint="Enter 7 digits only"
                            persistent-hint
                            prefix="1868"
                            maxlength="7"
                            clearable
                            :ref='field.ref'
                            :rules="[() => !isNaN(studentRecord[field.model]) || 'Only Numbers Allowed']"                            
                        ></v-text-field>
                                          
                        <v-menu
                            v-else-if="field.type == 'date'"
                            ref="menuBirthDate"
                            v-model="calendarMenu[field.modelMenu]"
                            :close-on-content-click="false"                           
                            transition="scale-transistion"
                            offset-y
                            min-width="290px"                            
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="studentRecord[field.model]"
                                    :label="field.label"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    :ref='field.ref'
                                    :rules="[()=> !!studentRecord[field.model] || 'This field is required.']"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="studentRecord[field.model]"                                
                                @input="setDate(field.label)"
                            >                                
                            </v-date-picker>                            
                        </v-menu>

                        <v-text-field
                            v-else-if="field.required && field.label == 'Email'"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            @blur="validateSection"
                            :prepend-icon="field.icon"                            
                            clearable
                            :ref="field.ref" 
                            :rules="[
                                () => !!studentRecord[field.model] || 'This field is required.', () => regex.test(studentRecord[field.model]) || 'Invalid e-mail' ]"                           
                        ></v-text-field>

                        <v-text-field
                            v-else-if="field.required"
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            @blur="validateSection"
                            :prepend-icon="field.icon"                            
                            clearable
                            :ref="field.ref" 
                            :rules="[()=> !!studentRecord[field.model] || 'This field is required.']"                           
                        ></v-text-field>

                        <v-text-field
                            v-else
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            @blur="validateSection"
                            :prepend-icon="field.icon"                            
                            clearable
                            :ref="field.ref"                            
                        ></v-text-field>

                    </v-col>                
                </v-row>            
            </v-card>
        </v-row>

        <v-row
            align="center"
            justify="center"
            v-if="section7"                        
        >
            <v-card
                class="pa-6 mt-5" 
                width="500"                
            >
                <v-row 
                    align="center"
                    justify="center"
                    v-for="field in sectionFields(7)"
                    :key="field.label"
                >
                    <v-col
                        cols="12"                        
                    >
                                                
                        <v-menu
                            v-if="field.type == 'date'"
                            ref="menu"
                            v-model="calendarMenu[field.modelMenu]"
                            :close-on-content-click="false"                           
                            transition="scale-transistion"
                            offset-y
                            min-width="290px"                            
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="studentRecord[field.model]"
                                    :label="field.label"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    :ref='field.ref'                                    
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="studentRecord[field.model]"                                
                                @input="setDate(field.label)"
                            >                                
                            </v-date-picker>                            
                        </v-menu>

                        <v-text-field
                            v-else
                            v-bind:label="field.label"
                            v-model="studentRecord[field.model]"
                            @blur="validateSection"
                            :prepend-icon="field.icon"
                        ></v-text-field>
                    </v-col>                    
                </v-row>
            </v-card>                
        </v-row>

    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'StudentData',
    components: {
        Layout,
    },
    
    data: () => ({
        fields: [
            { label: 'section 1', break: true, number: 1, display: true},
            {
                label: 'House', 
                model: 'house', 
                type: 'select', 
                disabled: true,
                filled: true,
                required: false,
                ref: 'house',
                section: 1,
            },
            {
                label: 'Class', 
                model: 'class', 
                type: 'select', 
                disabled: true,
                filled: true,
                required: false,
                ref: 'class',
                section: 1,
            },
            { label: 'section 2', break: true, number: 2, display: true},
            {
                label: 'First Name', 
                model: 'first_name', 
                type: 'text',
                required: true,
                ref: 'first_name',
                section: 2,
            },
            {
                label: 'Last Name', 
                model: 'last_name', 
                type: 'text',
                required: true,
                ref: 'last_name', 
                section: 2,
            },
            {
                label: 'Other Name', 
                model: 'middle_name', 
                type: 'text',
                required: false,
                ref: 'middle_name', 
                section: 2,
            },
            {
                label: 'Gender', 
                model: 'sex', 
                type: 'select',
                items: [{text: 'Female', value: 'F'}, {text: 'Male', value: 'M'}],
                required: true,
                ref: 'sex',
                section: 2,                
            },
            {label: 'section 3', break: true, number: 3, display: true},
            {
                label: 'Address', 
                model: 'home_address', 
                type: 'text', 
                icon: 'mdi-home',
                required: true,
                ref: 'home_address', 
                section: 3
            },
            {
                label: 'Town', 
                model: 'address_line_2', 
                type: "select",
                items: [],
                text: 'town_name',
                value: 'town_name',
                placeholder: 'Type to search for town',
                icon: 'mdi-city',
                required: true,
                ref: 'address_line_2',
                section: 3,
            },
            {
                label: 'Phone Number (Mobile)', 
                model: 'phone_cell', 
                type: 'phone-number', 
                icon: 'mdi-cellphone',
                required: false,
                section: 3,
            },
            {
                label: 'Email', 
                model: 'email', 
                type: "email", 
                icon: 'mdi-email',
                required: false,
                section: 3,
            },
            {
                label: 'Blood Group', 
                model: 'blood_type', 
                type: "select",
                items: [
                    'O-positive',
                    'O-negative',
                    'A-positive',
                    'A-negative',
                    'B-positive',
                    'B-negative',
                    'AB-positive',
                    'AB-negative'
                ],
                placeholder: 'Type to search for blood group',
                icon: 'mdi-water',
                required: false,                
                section: 3,
            },
            {label: 'section 4', break: true, number: 4, display: true},
            {
                label: 'Previous School', 
                model: 'previous_school', 
                type: 'text',
                required: true,
                section: 4,
            },
            {
                label: 'SEA Number', 
                model: 'sea_no', 
                type: 'text',
                required: true,
                section: 4,
            },
            {
                label: 'Religion', 
                model: 'religion_code', 
                type: 'select',
                items: [],
                text: 'religion',
                value: 'code',
                required: true,
                section: 4,
            },
            {
                label: 'Ethnic Group', 
                model: 'ethnic_group_code', 
                type: 'select',
                items: [],
                text: 'group_type',
                value: 'id',
                required: true,
                section: 4,
            },
            {label: 'section 5', break: true, number: 5, display: true},            
            {
                label: 'Electronic Birth Pin', 
                model: 'birth_certificate_no', 
                type: 'text', 
                icon: 'mdi-dialpad',
                required: true,
                section: 5,
            },            
            {
                label: 'Date of Birth', 
                model: 'date_of_birth',
                modelMenu: 'menuBirthDate',
                type: 'date', 
                icon: 'mdi-calendar',
                required: true,
                section: 5,
            },            
            {
                label: 'Country of Birth', 
                model: 'place_of_birth', 
                type: 'text', 
                icon: 'mdi-earth',
                required: true,
                section: 5,
            },
            {
                label: 'Nationality', 
                model: 'nationality', 
                type: 'text', 
                icon: 'mdi-flag',
                required: true,
                section: 5,
            },
            {label: 'section 6', break: true, number: 6, display: true},           
            {
                label: 'Do you have an Immigration Student Permit', 
                model: 'immigration_permit', 
                type: 'switch',
                required: false,
                section: 6,
            },
            {label: 'section 7', break: true, number: 7, display: false},   
            {
                label: 'Date of Issue', 
                model: 'permit_issue_date',
                modelMenu: 'menuIssueDate', 
                type: 'date',
                required: false,
                section: 7,
                display: false,
            },
            {
                label: 'Expiry Date', 
                model: 'permit_expiry_date',
                modelMenu: 'menuExpiryDate', 
                type: 'date',
                section: 7,
                required: false,
                display: false,
            },            
            {
                label: 'Second Language', 
                model: 'second_language', 
                type: 'text',
                icon: 'mdi-earth',
                section: 7,
                required: false,
                display: false,
            },
        ],        
        studentRecord: {},
        section7: false,
        immigrationPermit: false,        
        menu: false,        
        calendarMenu: {
            menuBirthDate: false,
            menuIssueDate: false,
            menuExpiryDate: false,
        },
        date: null,
        sectionValid: false,
        rules: {
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },

    }),

    mounted: function () {
        this.setStudentRecord();
        this.loadTowns();
        this.loadReligions();
        this.loadEthnicGroups();
        this.setStudentDataFields();
        this.setDialog(false);
    },
    
    computed: {
        ...mapGetters({
            getTowns: 'form/getTowns',
            getReligions: 'form/getReligions',
            getEthnicGroups: 'form/getEthnicGroups',
            schoolName: 'form/getSchoolName',
            primaryColor: 'form/getPrimaryColor',
            colorDarken: 'form/getColorDarken',
        }),
        sections(){
            return this.fields.filter( field => field.break == true);
        },
        themeColor(){          
          return this.primaryColor + ' ' + this.colorDarken;
        },
        regex(){
            return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) 
        }                            
    },

    watch: {
        immigrationPermit: {
            handler(newValue){
                this.section7 = newValue;
            }
        }

    },

    methods: {
        ...mapGetters({
            getStudentRecord: 'auth/getStudentRecord',            
        }),
        setStudentRecord(){
            this.studentRecord = {...this.getStudentRecord()} 
            console.log(this.studentRecord);           
            this.setUser(this.studentRecord.first_name.charAt(0)+this.studentRecord.last_name.charAt(0));
            if(this.studentRecord.immigration_permit == 1){
                this.immigrationPermit = true;
            }
            else{
                this.immigrationPermit = false;
            }
            if(this.studentRecord.terms_and_conditions == 0) this.setTermsAndConditions(false);
            else this.setTermsAndConditions(true);
            this.studentRecord.ethnic_group_code = parseInt(this.studentRecord.ethnic_group_code);
        },
        ...mapMutations({
            updateStudentRecord: 'auth/setStudentRecord',
            setTowns: 'form/setTowns',
            setReligions: 'form/setReligions',
            setEthnicGroups: 'form/setEthnicGroups',
            setStudentDataValidated: 'form/setStudentDataValidated',
            setValidationErrors: 'form/setValidationErrors',
            setUser: 'form/setUser',
            studentDataFields: 'form/setStudentDataFields',
            setTermsAndConditions: 'form/setTermsAndConditions',
            setDialog: 'form/setDialog',            
        }),
        ...mapActions({
            saveRecord: 'auth/saveRecord',
            retrieveTowns: 'form/retrieveTowns',
            retrieveReligions: 'form/retrieveReligions',
            retrieveEthnicGroups: 'form/retrieveEthnicGroups'
        }),
        updateStore(){            
            this.updateStudentRecord(this.studentRecord);
            this.saveRecord()
                .then(response => {
                    console.log(response.status);
                });
        },
        loadTowns(){
            this.retrieveTowns()
                .then(response => {                   
                    this.setTowns(response.data);
                    this.fields[10].items = this.getTowns;
                })
        },
        loadReligions(){
            this.retrieveReligions()
                .then(response => {
                    console.log(response);
                    this.setReligions(response.data);
                    this.fields[17].items = this.getReligions;
                })
        },
        loadEthnicGroups(){
            this.retrieveEthnicGroups()
                .then(response => {
                    this.setEthnicGroups(response.data);
                    this.fields[18].items = this.getEthnicGroups;
                })
        },
        sectionFields(number){
            return this.fields.filter( field => field.section == number);
        },
        setLabel(label){
            return label ? 'Yes' : 'No';
        },       
        toggleImmigration(){            
            if(this.immigrationPermit){
                this.studentRecord.immigration_permit = 1;
            }
            else{
                this.studentRecord.immigration_permit = 0;
            }
            this.validateSection();
        },        
        setDate(menu){            
            switch(menu){
                case 'Date of Birth':
                    this.calendarMenu.menuBirthDate = false;
                    break;
                case 'Expiry Date':
                    this.calendarMenu.menuExpiryDate = false;
                    break;
                case 'Date of Issue':
                    this.calendarMenu.menuIssueDate = false;
                    break;        
            }                     
            this.validateSection();
        }, 
        validateSection(){
            let sectionFields = this.fields.filter( field => field.break !== true);
            let validationErrors = [];
            let formHasErrors = false;
            
            sectionFields.forEach(element => {
                if(element.required && !this.studentRecord[element.model]) {                    
                    console.log(`${element.model} : false`);
                    formHasErrors = true;
                    validationErrors.push(`${element.label} is required.`);
                }
                
                if(!formHasErrors) this.setStudentDataValidated(true);
                else this.setStudentDataValidated(false);
            })

            this.setValidationErrors(validationErrors);
            this.updateStore();
        },
        setStudentDataFields(){
            let sectionFields = this.fields.filter( field => field.break !== true);
            this.studentDataFields(sectionFields);
        },
              
    },
    
}
</script>